/*
 * MOOJO — Vidéo éditoriale en page (in-page editorial video).
 * Lecture muette à l'entrée dans le viewport, pause à la sortie, son et
 * plein écran explicites. Aucune navigation externe : le documentaire long
 * passe par `moojo-video-modal`.
 *
 * Markup attendu :
 *   [data-moojo-inline-video]        conteneur
 *     video                          la vidéo
 *     [data-moojo-video-play]        lecture / pause   (facultatif)
 *     [data-moojo-video-sound]       son on / off      (facultatif)
 *     [data-moojo-video-fullscreen]  plein écran       (facultatif)
 */
(function () {
  if (window.MoojoInlineVideo) return;

  var PLAY_IN = 0.35;
  var PAUSE_OUT = 0.1;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setup(frame) {
    if (frame.dataset.moojoInlineVideoBound === 'true') return;
    frame.dataset.moojoInlineVideoBound = 'true';

    var video = frame.querySelector('video');
    if (!video) return;

    var playBtn = frame.querySelector('[data-moojo-video-play]');
    var soundBtn = frame.querySelector('[data-moojo-video-sound]');
    var fsBtn = frame.querySelector('[data-moojo-video-fullscreen]');
    var reduced = prefersReducedMotion();

    // Le son n'est jamais une surprise : muet par defaut, quoi qu'il arrive.
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    // reduced = pas de lecture automatique. La video reste disponible au clic.
    var userPaused = reduced;
    frame.dataset.moojoVideoState = userPaused ? 'paused' : 'idle';

    function syncState() {
      frame.dataset.moojoVideoState = video.paused ? 'paused' : 'playing';
      if (playBtn) {
        playBtn.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
        var label = playBtn.querySelector('[data-label]');
        if (label) label.textContent = video.paused ? 'Lire la video' : 'Mettre en pause';
      }
    }

    function attemptPlay() {
      if (userPaused) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          frame.dataset.moojoAutoplayBlocked = 'true';
          syncState();
        });
      }
    }

    if (!reduced && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= PLAY_IN) {
              attemptPlay();
            } else if (entry.intersectionRatio < PAUSE_OUT && !video.paused) {
              video.pause();
            }
          });
        },
        { threshold: [0, PAUSE_OUT, PLAY_IN, 0.6] }
      );
      io.observe(frame);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) {
          userPaused = false;
          video.play();
        } else {
          userPaused = true;
          video.pause();
        }
        syncState();
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        var label = soundBtn.querySelector('[data-label]');
        if (label) label.textContent = video.muted ? 'Activer le son' : 'Couper le son';
        if (!video.muted && video.paused) {
          userPaused = false;
          video.play();
        }
      });
    }

    if (fsBtn) {
      fsBtn.addEventListener('click', function () {
        if (document.fullscreenElement) {
          document.exitFullscreen();
          return;
        }
        if (frame.requestFullscreen) {
          frame.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (frame.webkitRequestFullscreen) {
          frame.webkitRequestFullscreen();
        }
      });
    }

    video.addEventListener('play', syncState);
    video.addEventListener('pause', syncState);
    syncState();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-moojo-inline-video]').forEach(setup);
  }

  window.MoojoInlineVideo = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
